module.exports = __webpack_public_path__ + "img/icon-delay.3dcf35cc.png";